import styles from "./topbar.module.scss";

const Topbar = ({ isOpen, clickHandle }) => {
  return (
    <div className={styles.topbar}>
      <div className={styles.right}>
        <div className={styles.hamburger} onClick={clickHandle}>
          <span
            className={`${styles.hamburger_lines} ${isOpen ? styles.open : ""}`}
          ></span>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
